import type { ReactNode } from "react";
import { ui } from "../lib/ui";

interface AsyncBlockProps {
  loading: boolean;
  error: string | null;
  empty?: boolean;
  emptyMessage?: string;
  children: ReactNode;
}

/** Uniform loading / error / empty handling so every panel reads the same. */
export function AsyncBlock({
  loading,
  error,
  empty,
  emptyMessage = "No data for this range.",
  children,
}: AsyncBlockProps) {
  if (error) return <p className={`${ui.notice} ${ui.noticeError}`}>{error}</p>;
  if (loading) return <p className={`${ui.notice} text-muted`}>Loading…</p>;
  if (empty) return <p className={`${ui.notice} text-muted`}>{emptyMessage}</p>;
  return <>{children}</>;
}
